const changeType = {
  SAME_CYCLE: "SAME_CYCLE",
  MONTHLY_TO_YEARLY: "MONTHLY_TO_YEARLY",
  ANNUAL_TO_MONTHLY: "ANNUAL_TO_MONTHLY",
};

export const determineCycleChange = (oldCycle, newCycle) => {
  if (oldCycle === newCycle) {
    return changeType.SAME_CYCLE;
  } else if (oldCycle === "monthly" && newCycle === "yearly") {
    return changeType.MONTHLY_TO_YEARLY;
  } else if (oldCycle === "yearly" && newCycle === "monthly") {
    return changeType.ANNUAL_TO_MONTHLY;
  }
  throw new Error("Invalid billing cycle conversion");
};

export const calculatePriceDifference = (
  planChangeType,
  oldPrice,
  newPrice,
  subscriptionDays,
  daysLeftInSubscription,
) => {
  switch (planChangeType) {
    case changeType.SAME_CYCLE:
      return calculateSameCycleProrationPrice(
        oldPrice,
        newPrice,
        subscriptionDays,
        daysLeftInSubscription,
      );
    case changeType.MONTHLY_TO_YEARLY:
      return calculateMonthlyToAnnualProration(
        oldPrice,
        newPrice,
        subscriptionDays,
        daysLeftInSubscription,
      );
    case changeType.ANNUAL_TO_MONTHLY:
      return 0;
    default:
      throw new Error("Invalid plan change type");
  }
};

function calculateSameCycleProrationPrice(
  oldPrice,
  newPrice,
  subscriptionDays,
  daysLeftInSubscription,
) {
  // Use existing logic from base class
  const unusedAmount = (oldPrice / subscriptionDays) * daysLeftInSubscription;

  const proratedNewAmount =
    (newPrice / subscriptionDays) * daysLeftInSubscription;

  return Number((proratedNewAmount - unusedAmount).toFixed(2));
}

function calculateMonthlyToAnnualProration(
  oldPrice,
  newPrice,
  subscriptionDays,
  daysLeftInSubscription,
) {
  // Calculate unused portion of current monthly period
  const unusedAmount = (oldPrice / subscriptionDays) * daysLeftInSubscription;

  // Net charge
  return Number((newPrice - unusedAmount).toFixed(2));
}
